import PropTypes from "prop-types";
import { NftPrize } from "./NftPrize";
import s from "./PrizeWallet.module.css";

const getBalanceCount = (_data) => {
    //console.log(`DataL ${JSON.stringify(_data)}`);

    const balance = _data.reduce(
        (n, { balance }) => Number(n) + Number(balance),
        0
    );
    return balance;
};

const PrizeWallet = ({ nfts, count }) => {
    return (
        <div className={s.outerContainer}>
            {Object.keys(nfts)
                .sort((a, b) => {
                    return nfts[a][0].contract.name < nfts[b][0].contract.name
                        ? -1
                        : nfts[a][0].contract.name > nfts[b][0].contract.name
                        ? 1
                        : 0;
                })
                .map((key) => {
                    return (
                        <div
                            key={nfts[key][0].contract.address}
                            className={s.innerContainer}
                        >
                            <div
                                key={`head:${nfts[key][0].contract.address}`}
                                className={s.contractHeader}
                            >
                                {nfts[key][0].contract.name
                                    ? nfts[key][0].contract.name
                                    : "Undefined"}{" "}
                                - Count: {getBalanceCount(nfts[key])} - Odds:{" "}
                                {count > 0
                                    ? `${(
                                          (getBalanceCount(nfts[key]) / count) *
                                          100
                                      ).toFixed(2)}%`
                                    : "e"}
                            </div>
                            <div className={s.contractContainer}>
                                {nfts[key].map((data) => {
                                    return (
                                        <NftPrize
                                            key={`${data.contract.address}:${data.tokenId}`}
                                            data={data}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

PrizeWallet.propTypes = {
    nfts: PropTypes.object,
    count: PropTypes.number,
};

export { PrizeWallet };
